<template>
  <el-dialog
          title="分享课件"
          :visible.sync="dialogVisible"
          width="400px"
          :append-to-body="true"
          :close-on-click-modal="false"
          :before-close="handleClose">
    <div class="share-box" v-loading="cocosLoading">
      <p class="row">
        <span class="name">课件名称：</span>
        <span class="value">{{name}}</span>
      </p>
      <div class="row" v-if="showDev">
        <span class="name">版本选择：</span>
        <p class="value">
        <el-select v-model="cocosVal" filterable size="small" style="width:200px" placeholder="cocos版本号">
            <el-option
              v-for="item in cocosOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              >
            </el-option>
          </el-select>
        </p>
      </div>
      <div class="row"  v-if="showDev">
        <span class="name">固定地址：</span>
        <p class="value">
          <el-input
                  class="input" size="small"
                  v-model="defaultUrl"
                  placeholder="请输入固定地址"
                  @keyup.enter.native.stop="handleGenerateLink"
          ></el-input>
         <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="handleGenerateLink"
          >生成链接</el-button>
        </p>
      </div>
      <div class="row"  v-if="!showDev">
        <span class="name">访问密码：</span>
        <p class="value">
          <el-input
                  class="input" size="small"
                  v-model="password"
                  placeholder="请输入分享密码"
                  maxlength="6"
                  show-word-limit
                  @keyup.enter.native.stop="handleGenerateLink"
          ></el-input>
          <el-button
                  size="small"
                  type="primary"
                  plain
                  @click="handleGenerateLink"
          >生成链接</el-button>
        </p>
      </div>
      <div class="row">
        <span class="name">分享链接：</span>
        <p class="value">
          <el-input
                  class="input"
                  readonly
                  size="small"
                  v-model="link"
                  placeholder="输入密码点击生成链接"
          ></el-input>
          <el-button
                  size="small"
                  type="success"
                  plain
                  v-clipboard:copy="link"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
          >复制链接</el-button>
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import * as GlobalServer from '@/api/global'
  import * as ResultServer from '../../api/result'
  import Config from '../../config/app'
  export default {
    name: 'share-course',
    props: {
      id: [Number, String],
      name: String,
      visible: Boolean,
      value: [Object, String],
      defaultValue: Object
    },
    watch: {
      visible (vl) { this.dialogVisible = vl },
      dialogVisible (vl) { this.$emit('update:visible', vl) }
      // value (vl) { this.form = vl },
      // 'form.value': {
      //   handler (vl) {
      //     this.$emit('update:value', vl)
      //   }
      // },
      //   defaultValue: {
      //     handler (vl) {
      //       this.form.map(v => {
      //         if (v.type === 'Select') {
      //           v.value = `${vl[v.attr]}`
      //         } else if (v.type === 'UploadTencent') {
      //           const img = vl[v.attr].split(',')
      //           v.value = img && img.map(v => { return { url: v } })
      //         } else {
      //           v.value = vl[v.attr]
      //         }
      //       })
      //     },
      //     deep: true,
      //     immediate: true
      //   }
    },
    created () {
      this.init()
    },
    data () {
      return {
        dialogVisible: this.visible,
        password: '',
        link: '',
        defaultUrl:'127.0.0.1:8080',
         showDev: false,
         cocosVal:this.$store.state.curCocosDevUrl,
         cocosOptions:[],
         cocosLoading:false

      }
    },
    methods: {
      init () {
        // this.getNameList()
        console.log('Config.domain', Config.domain)
        if(Config.domain !== 'yunkedun.com') {
            this.showDev = true
            this.password = '123456'
            this.getCocosPackList()
        }
      },
      // 获取cocos包列表
    async getCocosPackList(version){
      this.cocosLoading = true
      try {
          const res = await GlobalServer.getCocosPackList({versionOrder: 'desc',version})
          this.cocosLoading = false
          const arr = res.items.map(v=>{
              return {
                  key: v?.attach?.unpack_url,
                  value: v.version
              }
              })
          this.cocosOptions = arr
          this.cocosVal = arr[0].value
      } catch (e) {
          console.log('获取cocos包列表失败==>', e)
      }
  },    
      async handleGenerateLink () {
        if (!this.password) {
          this.$message.error('请先输入分享密码')
          return false
        }
        this.cocosLoading = true
        // console.log('this.password', this.password)
        const res = await ResultServer.getShareAddress({
          id: this.id,
          password: this.password,
          clientsId: this.$store.state.initConfig.school_id
        })
      this.cocosLoading = false
        // 拼接分享地址
      const link = this.link = `${Config.shareWeb}?id=${res.id}`
      const linkDev = `${Config.shareWeb}?id=${res.id}&version=${this.cocosVal}&gameSceneProxy=${this.defaultUrl}`
      this.link = Config.domain !== 'yunkedun.com' ? linkDev : link
      },
      onCopy () {
        this.$message.success('复制成功')
      },
      onError () {
        this.$message.error('复制失败')
      },
      async getNameList () {
        const res = await this.apiConfig.nameApi({
          clientsId: this.$store.state.selectSchoolId,
          per_page: 1000
        })
        let data = res.items.map(v => {
          return {
            key: v.id,
            value: v.name,
            ...v
          }
        })
        // 如果是移动，则名称不包括当前id分类
        if (this.isMove) {
          data = data.filter(v => `${v.id}` !== `${this.id}`)
        }
        this.form[0].options = data
        console.log('res==>getNameList', res)
      },
      async getTypeList (parentId) {
        const res = await this.apiConfig.listApi({
          clientsId: this.$store.state.selectSchoolId,
          parentId
        })
        this.form[1].options = this.getNewObj(res.data.childrens)
      },
      getNewObj (arr) {
        let obj = null
        return arr.map(v => {
          obj = {
            key: v.id,
            value: v.name,
            ...v
          }
          if (v.childrens && v.childrens.length > 0)obj.children = this.getNewObj(v.childrens)
          return obj
        })
      },
      onAttr (item, target, index) {
        console.log('attr==>', item, target, index)
        switch (item.attr) {
          case 'name':
            this.getTypeList(target)
            break
        }
      },
      handleClose () {
        this.dialogVisible = false
      },
      submit () {
        const state = this.$refs.form.validateForm()
        const obj = {}
        if (state) {
          let newValue = ''
          this.form.map(v => {
            newValue = v.value
            if (v.type === 'Select') {
              obj[v.attr] = `${v.value}`
            } else if (v.type === 'Cascader') {
              if (v.value && v.value.length > 0) {
                newValue = v.value[v.value.length - 1]
              }
              obj[v.attr] = newValue
            } else {
              obj[v.attr] = v.value
            }
          })
          console.log('submit', obj)
          // debugger
          this.$emit('success', obj)
          this.handleClose()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .row{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;

    .value{
      display: flex;
      flex-direction: row;
      align-items: center;

      .input {
        margin-right: 10px;
      }
    }
  }
</style>
